import { FormattedMessage } from "react-intl";

const RenderUpdateMessage = (state: Record<string, any>): React.JSX.Element => {
  let messageElement: any = "";

  if (state.updateSuccess) {
    messageElement = (
      <div className="profile__notification profile__notification--success">
        <FormattedMessage tagName="span" id="profile-update-success" />
      </div>
    );
  } else if (state.updateFailed) {
    messageElement = (
      <div className="profile__notification profile__notification--failed">
        <FormattedMessage tagName="span" id="profile-update-failed" />
      </div>
    );
  }

  return messageElement;
};

export default RenderUpdateMessage;
